import { lazy, Suspense } from "react";
import Layout from "./Components/Layout";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { mainRouteInitial } from "./Data/Constant";
import "./App.css";

const HomePage = lazy(() => import("./Pages/HomePage"));
const BlogPage = lazy(() => import("./Pages/BlogPage"));
const ReadBlogPage = lazy(() => import("./Pages/ReadBlogPage"));
const ContactUsPage = lazy(() => import("./Pages/ContactUsPage"));

function App() {
  const router = createBrowserRouter([
    {
      path: `/${mainRouteInitial}/`,
      element: <Layout />,
      children: [
        {
          path: "Home",
          element: (
            <Suspense fallback={<div>Loading...</div>}>
              <HomePage />
            </Suspense>
          ),
        },
        {
          path: "Blog",
          element: (
            <Suspense fallback={<div>Loading...</div>}>
              <BlogPage />
            </Suspense>
          ),
        },
        {
          path: "ReadBlog",
          element: (
            <Suspense fallback={<div>Loading...</div>}>
              <ReadBlogPage />
            </Suspense>
          ),
        },
        {
          path: "ContactUs",
          element: (
            <Suspense fallback={<div>Loading...</div>}>
              <ContactUsPage />
            </Suspense>
          ),
        },
      ],
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
